(function () {
  'use strict';

  if (window.KMProductCardFitment) return;
  window.KMProductCardFitment = true;

  var componentSelector = '[data-product-card-fitment]';
  var pendingSelector = componentSelector + '[data-fitment-pending]';
  var globoCardSelector = '.grid-product';
  var globoGridClass = 'gf-products--fitment-layout';
  var globoControlsReadyAttribute = 'data-gf-products-ready';
  var globoRowHeightAttribute = 'data-fitment-row-height';
  var globoRowHeightProperty = '--fitment-row-meta-height';
  var mobileMedia = window.matchMedia('(max-width: 767px)');
  var dataRequests = new Map();
  var dataRequestQueue = [];
  var activeDataRequests = 0;
  var maxConcurrentDataRequests = 6;
  var closeTimers = new WeakMap();
  var suppressedFocusOpen = new WeakSet();
  var uniqueId = 0;
  var hydrationQueued = false;
  var rowAlignmentQueued = false;
  var viewportWidth = document.documentElement.clientWidth;

  function closestElement(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function syncGloboControls() {
    var controls = document.getElementById('gf-controls-container');
    var products = document.getElementById('gf-products');
    var isReady = Boolean(products && products.querySelector(globoCardSelector));

    if (isReady && !products.classList.contains(globoGridClass)) {
      products.classList.add(globoGridClass);
      scheduleGloboRowAlignment();
    }

    if (!controls) return;

    if (isReady) {
      controls.setAttribute(globoControlsReadyAttribute, '');
    } else {
      controls.removeAttribute(globoControlsReadyAttribute);
    }
  }

  function alignGloboCardRows() {
    rowAlignmentQueued = false;

    var products = document.getElementById('gf-products');
    if (!products) return;

    var cards = Array.from(products.children).filter(function (card) {
      return card.matches && card.matches(globoCardSelector) && card.offsetWidth > 0;
    });

    if (!cards.length) return;

    cards.forEach(function (card) {
      card.removeAttribute(globoRowHeightAttribute);
      card.style.removeProperty(globoRowHeightProperty);
    });

    var rows = [];

    cards.forEach(function (card) {
      var top = card.offsetTop;
      var meta = card.querySelector('.grid-product__content > .grid-product__link > .grid-product__meta');
      var row = rows[rows.length - 1];

      if (!meta) return;

      if (!row || Math.abs(row.top - top) > 1) {
        row = { top: top, metaHeight: 0, cards: [] };
        rows.push(row);
      }

      row.metaHeight = Math.max(row.metaHeight, meta.offsetHeight);
      row.cards.push(card);
    });

    rows.forEach(function (row) {
      var height = Math.ceil(row.metaHeight) + 'px';

      row.cards.forEach(function (card) {
        card.style.setProperty(globoRowHeightProperty, height);
        card.setAttribute(globoRowHeightAttribute, '');
      });
    });
  }

  function scheduleGloboRowAlignment() {
    if (rowAlignmentQueued) return;
    rowAlignmentQueued = true;

    window.requestAnimationFrame(alignGloboCardRows);
  }

  function mutationTouchesGloboGrid(record) {
    var target = record.target;

    if (
      target &&
      target.nodeType === 1 &&
      ((target.matches && target.matches('#gf-products')) || closestElement(target, '#gf-products'))
    ) {
      return true;
    }

    return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
      if (!node || node.nodeType !== 1) return false;

      return (
        (node.matches && node.matches('#gf-products, ' + globoCardSelector)) ||
        closestElement(node, '#gf-products') ||
        (node.querySelector && node.querySelector('#gf-products, ' + globoCardSelector))
      );
    });
  }

  function normalizeModels(models) {
    var seen = new Set();

    return (Array.isArray(models) ? models : []).reduce(function (result, model) {
      var value = String(model || '').trim();
      var key = value.toLowerCase();

      if (value && !seen.has(key)) {
        seen.add(key);
        result.push(value);
      }

      return result;
    }, []);
  }

  function createSvg(className, shapes) {
    var namespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(namespace, 'svg');

    svg.setAttribute('class', className);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');

    shapes.forEach(function (shape) {
      var element = document.createElementNS(namespace, shape.name);
      Object.keys(shape.attributes).forEach(function (attribute) {
        element.setAttribute(attribute, shape.attributes[attribute]);
      });
      svg.appendChild(element);
    });

    return svg;
  }

  function vehicleIcon() {
    return createSvg('product-card-fitment__icon product-card-fitment__icon--vehicle', [
      { name: 'path', attributes: { d: 'm21 8-2 2-1.5-3.7A2 2 0 0 0 15.65 5h-7.3A2 2 0 0 0 6.5 6.3L5 10 3 8' } },
      { name: 'rect', attributes: { width: '18', height: '8', x: '3', y: '10', rx: '2' } },
      { name: 'path', attributes: { d: 'M7 14h.01M17 14h.01M5 18v2M19 18v2' } }
    ]);
  }

  function infoIcon() {
    return createSvg('product-card-fitment__icon product-card-fitment__icon--info', [
      { name: 'circle', attributes: { cx: '12', cy: '12', r: '10' } },
      { name: 'path', attributes: { d: 'M12 16v-4M12 8h.01' } }
    ]);
  }

  function closeIcon() {
    return createSvg('', [
      { name: 'path', attributes: { d: 'M18 6 6 18M6 6l12 12' } }
    ]);
  }

  function renderComponent(component, models) {
    var cleanModels = normalizeModels(models);

    component.removeAttribute('data-fitment-pending');

    if (!cleanModels.length) {
      component.hidden = true;
      return;
    }

    uniqueId += 1;
    var popoverId = 'ProductCardFitmentDynamic-' + uniqueId;
    var trigger = document.createElement('div');
    var summary = document.createElement('span');
    var popover = document.createElement('div');
    var header = document.createElement('div');
    var title = document.createElement('span');
    var close = document.createElement('span');
    var list = document.createElement('ul');

    component.replaceChildren();
    component.className = 'product-card-fitment';
    component.hidden = false;
    component.setAttribute('data-fitment-ready', '');

    trigger.className = 'product-card-fitment__trigger';
    trigger.setAttribute('data-fitment-trigger', '');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', popoverId);

    summary.className = 'product-card-fitment__text';
    summary.textContent = 'Fits ' + cleanModels.join(' · ');

    trigger.appendChild(vehicleIcon());
    trigger.appendChild(summary);
    trigger.appendChild(infoIcon());

    popover.className = 'product-card-fitment__popover';
    popover.id = popoverId;
    popover.hidden = true;
    popover.setAttribute('data-fitment-popover', '');
    popover.setAttribute('role', 'dialog');
    popover.setAttribute('aria-labelledby', popoverId + '-title');

    header.className = 'product-card-fitment__popover-header';
    title.className = 'product-card-fitment__popover-title';
    title.id = popoverId + '-title';
    title.textContent = 'Compatible models';

    close.className = 'product-card-fitment__close';
    close.setAttribute('data-fitment-close', '');
    close.setAttribute('role', 'button');
    close.setAttribute('tabindex', '0');
    close.setAttribute('aria-label', 'Close compatible models');
    close.appendChild(closeIcon());

    header.appendChild(title);
    header.appendChild(close);

    list.className = 'product-card-fitment__models';
    cleanModels.forEach(function (model) {
      var item = document.createElement('li');
      item.className = 'product-card-fitment__model';
      item.textContent = model;
      list.appendChild(item);
    });

    popover.appendChild(header);
    popover.appendChild(list);
    component.appendChild(trigger);
    component.appendChild(popover);
  }

  function startDataRequest(queuedRequest) {
    activeDataRequests += 1;

    Promise.resolve()
      .then(queuedRequest.task)
      .then(function (result) {
        activeDataRequests -= 1;
        queuedRequest.resolve(result);
        runDataRequestQueue();
      }, function (error) {
        activeDataRequests -= 1;
        queuedRequest.reject(error);
        runDataRequestQueue();
      });
  }

  function runDataRequestQueue() {
    while (activeDataRequests < maxConcurrentDataRequests && dataRequestQueue.length) {
      startDataRequest(dataRequestQueue.shift());
    }
  }

  function queueDataRequest(task) {
    return new Promise(function (resolve, reject) {
      dataRequestQueue.push({
        task: task,
        resolve: resolve,
        reject: reject
      });
      runDataRequestQueue();
    });
  }

  function createProductFitmentUrl(endpointTemplate, handle) {
    if (!endpointTemplate || endpointTemplate.indexOf('__HANDLE__') === -1) {
      throw new Error('Fitment product URL template is invalid');
    }

    return new URL(
      endpointTemplate.replace('__HANDLE__', encodeURIComponent(handle)),
      window.location.origin
    ).toString();
  }

  async function fetchProductFitments(endpoint) {
    var response = await fetch(endpoint, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Fitment data request failed with status ' + response.status);
    }

    var payload = await response.json();
    if (!payload || !Array.isArray(payload.models)) {
      throw new Error('Fitment data response is invalid');
    }

    return normalizeModels(payload.models);
  }

  function getProductFitments(endpointTemplate, handle) {
    var requestUrl = createProductFitmentUrl(endpointTemplate, handle);

    if (!dataRequests.has(requestUrl)) {
      var request = queueDataRequest(function () {
        return fetchProductFitments(requestUrl);
      }).catch(function (error) {
        dataRequests.delete(requestUrl);
        throw error;
      });
      dataRequests.set(requestUrl, request);
    }

    return dataRequests.get(requestUrl);
  }

  function resolveEndpoint() {
    var productTemplate = document.getElementById('gspfProduct');
    return productTemplate ? productTemplate.getAttribute('data-fitment-data-url') || '' : '';
  }

  function hydratePending(scope) {
    var pending = [];

    if (scope && scope.matches && scope.matches(pendingSelector)) pending.push(scope);
    if (scope && scope.querySelectorAll) {
      pending = pending.concat(Array.from(scope.querySelectorAll(pendingSelector)));
    }

    var groups = new Map();
    pending.forEach(function (component) {
      var globoCard = closestElement(component, globoCardSelector);
      var globoGrid = globoCard && closestElement(globoCard, '#gf-products');

      if (globoGrid) globoGrid.classList.add(globoGridClass);

      var endpointTemplate = resolveEndpoint();
      var handle = component.getAttribute('data-product-handle') || '';
      if (!endpointTemplate || !handle) return;

      var groupKey = endpointTemplate + '::' + handle;
      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          endpointTemplate: endpointTemplate,
          handle: handle,
          components: []
        });
      }
      groups.get(groupKey).components.push(component);
    });

    groups.forEach(function (group) {
      getProductFitments(group.endpointTemplate, group.handle)
        .then(function (models) {
          group.components.forEach(function (component) {
            if (!component.isConnected || !component.hasAttribute('data-fitment-pending')) return;
            renderComponent(component, models);
          });
        })
        .catch(function (error) {
          group.components.forEach(function (component) {
            component.setAttribute('data-fitment-error', '');
          });
          console.warn('[Product card fitment]', group.handle, error);
        });
    });
  }

  function scheduleHydration() {
    if (hydrationQueued) return;
    hydrationQueued = true;

    window.requestAnimationFrame(function () {
      hydrationQueued = false;
      hydratePending(document);
    });
  }

  function clearCloseTimer(component) {
    var timer = closeTimers.get(component);
    if (timer) window.clearTimeout(timer);
    closeTimers.delete(component);
  }

  function sizePopover(component) {
    var popover = component.querySelector('[data-fitment-popover]');
    var card = closestElement(component, '.grid-product');
    if (!popover || !card || popover.hidden) return;

    var surface = card.querySelector('.grid-product__content') || card;
    var surfaceRect = surface.getBoundingClientRect();
    var componentRect = component.getBoundingClientRect();
    var left;
    var width;
    var maxWidth;

    if (mobileMedia.matches) {
      var productList = closestElement(component, '#gf-products, [data-globo-filter-items]');
      var productListRect = productList ? productList.getBoundingClientRect() : null;

      if (!productListRect || productListRect.width <= 0) productListRect = surfaceRect;

      width = 'max-content';
      maxWidth = productListRect.width;

      component.style.setProperty('--fitment-popover-left', '0px');
      component.style.setProperty('--fitment-popover-width', width);
      component.style.setProperty('--fitment-popover-max-width', maxWidth + 'px');

      var measuredWidth = popover.getBoundingClientRect().width;
      var popoverLeft = Math.max(
        productListRect.left,
        Math.min(componentRect.left, productListRect.right - measuredWidth)
      );

      left = popoverLeft - componentRect.left;
    } else {
      var actions = Array.from(card.querySelectorAll('.add-form .add-to-cart, .add-form .btn-link'));
      var action = actions.find(function (candidate) {
        var rect = candidate.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      });
      var actionRect = action ? action.getBoundingClientRect() : null;

      if (actionRect) {
        left = actionRect.left - componentRect.left;
        width = actionRect.width + 'px';
        maxWidth = actionRect.width;
      } else {
        width = surfaceRect.width * 0.84 + 'px';
        maxWidth = surfaceRect.width * 0.84;
        left = surfaceRect.left + surfaceRect.width * 0.08 - componentRect.left;
      }
    }

    component.style.setProperty('--fitment-popover-left', left + 'px');
    component.style.setProperty('--fitment-popover-width', width);
    component.style.setProperty('--fitment-popover-max-width', maxWidth + 'px');

    var popoverRect = popover.getBoundingClientRect();
    var desiredArrowLeft = componentRect.left + 24 - popoverRect.left;
    var arrowLeft = Math.max(16, Math.min(desiredArrowLeft, popoverRect.width - 16));
    component.style.setProperty('--fitment-arrow-left', arrowLeft + 'px');
  }

  function setOpen(component, shouldOpen, restoreFocus) {
    var trigger = component && component.querySelector('[data-fitment-trigger]');
    var popover = component && component.querySelector('[data-fitment-popover]');
    var card = component && closestElement(component, '.grid-product');
    if (!trigger || !popover) return;

    clearCloseTimer(component);

    if (shouldOpen) {
      document.querySelectorAll(componentSelector + '.is-open').forEach(function (openComponent) {
        if (openComponent !== component) setOpen(openComponent, false);
      });
    }

    component.classList.toggle('is-open', shouldOpen);
    popover.hidden = !shouldOpen;
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    if (card) card.classList.toggle('is-fitment-open', shouldOpen);

    if (shouldOpen) {
      sizePopover(component);
    } else if (restoreFocus) {
      suppressedFocusOpen.add(component);
      trigger.focus();
      window.setTimeout(function () {
        suppressedFocusOpen.delete(component);
      }, 0);
    }
  }

  function scheduleClose(component) {
    clearCloseTimer(component);
    closeTimers.set(component, window.setTimeout(function () {
      setOpen(component, false);
    }, 120));
  }

  document.addEventListener('pointerover', function (event) {
    if (mobileMedia.matches) return;
    var component = closestElement(event.target, componentSelector);
    if (!component || !component.hasAttribute('data-fitment-ready')) return;
    if (suppressedFocusOpen.has(component)) {
      suppressedFocusOpen.delete(component);
      return;
    }
    clearCloseTimer(component);
    setOpen(component, true);
  });

  document.addEventListener('pointerout', function (event) {
    if (mobileMedia.matches) return;
    var component = closestElement(event.target, componentSelector);
    if (!component || (event.relatedTarget && component.contains(event.relatedTarget))) return;
    scheduleClose(component);
  });

  document.addEventListener('focusin', function (event) {
    if (mobileMedia.matches) return;
    var component = closestElement(event.target, componentSelector);
    if (!component || !component.hasAttribute('data-fitment-ready')) return;
    clearCloseTimer(component);
    setOpen(component, true);
  });

  document.addEventListener('focusout', function (event) {
    if (mobileMedia.matches) return;
    var component = closestElement(event.target, componentSelector);
    if (!component || (event.relatedTarget && component.contains(event.relatedTarget))) return;
    scheduleClose(component);
  });

  document.addEventListener('click', function (event) {
    var component = closestElement(event.target, componentSelector);

    if (!component) {
      document.querySelectorAll(componentSelector + '.is-open').forEach(function (openComponent) {
        setOpen(openComponent, false);
      });
      return;
    }

    var closeControl = closestElement(event.target, '[data-fitment-close]');
    var triggerControl = closestElement(event.target, '[data-fitment-trigger]');

    if (!closeControl && !triggerControl) return;

    event.preventDefault();
    event.stopPropagation();

    if (closeControl) {
      setOpen(component, false, true);
      return;
    }

    if (triggerControl) {
      var shouldOpen = mobileMedia.matches ? !component.classList.contains('is-open') : true;
      setOpen(component, shouldOpen);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!closestElement(event.target, '[data-fitment-popover]')) return;

    event.preventDefault();
    event.stopPropagation();
  });

  document.addEventListener('keydown', function (event) {
    var component = closestElement(event.target, componentSelector);

    if (event.key === 'Escape') {
      var openComponent = component && component.classList.contains('is-open')
        ? component
        : document.querySelector(componentSelector + '.is-open');

      if (openComponent) {
        event.preventDefault();
        setOpen(openComponent, false, true);
      }
      return;
    }

    if (!component || (event.key !== 'Enter' && event.key !== ' ')) return;

    if (closestElement(event.target, '[data-fitment-close]')) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(component, false, true);
      return;
    }

    if (closestElement(event.target, '[data-fitment-trigger]')) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(component, !component.classList.contains('is-open'));
    }
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll(componentSelector + '.is-open').forEach(sizePopover);

    var currentViewportWidth = document.documentElement.clientWidth;
    if (currentViewportWidth !== viewportWidth) {
      viewportWidth = currentViewportWidth;
      scheduleGloboRowAlignment();
    }
  });

  window.addEventListener('load', scheduleGloboRowAlignment);
  window.addEventListener('pageshow', scheduleGloboRowAlignment);

  document.addEventListener('load', function (event) {
    if (event.target && event.target.tagName === 'IMG' && closestElement(event.target, globoCardSelector)) {
      scheduleGloboRowAlignment();
    }
  }, true);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleGloboRowAlignment);
  }

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', function () {
      document.querySelectorAll(componentSelector + '.is-open').forEach(function (component) {
        setOpen(component, false);
      });
    });
  }

  var observer = new MutationObserver(function (records) {
    syncGloboControls();

    var hasPendingNode = records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          (node.matches && node.matches(pendingSelector)) ||
          (node.querySelector && node.querySelector(pendingSelector))
        );
      });
    });

    if (hasPendingNode) scheduleHydration();
    if (records.some(mutationTouchesGloboGrid)) scheduleGloboRowAlignment();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  syncGloboControls();
  scheduleGloboRowAlignment();
  hydratePending(document);
})();
